import { initializeApp } from 'firebase/app';
import {
  initializeAuth,
  indexedDBLocalPersistence,
  browserLocalPersistence,
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import nativeConfig from '../../firebase-test-config.json';

const androidClient = nativeConfig.client.find(
  client => client.client_info.android_client_info.package_name === 'com.staffmanager',
);
const projectId = nativeConfig.project_info.project_id;
const firebaseConfig = {
  apiKey: androidClient.api_key[0].current_key,
  authDomain: `${projectId}.firebaseapp.com`,
  projectId,
  storageBucket: nativeConfig.project_info.storage_bucket,
  messagingSenderId: nativeConfig.project_info.project_number,
  appId: androidClient.client_info.mobilesdk_app_id,
};

export const app = initializeApp(firebaseConfig);

// IndexedDB persistence keeps the session alive across tab closes, app restarts
// and — for an installed home-screen PWA — indefinitely. Employees stay signed
// in until they explicitly log out or the token is revoked server-side.
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence],
});

export const db = getFirestore(app);
export const storage = getStorage(app);
